// Modules
import { Action, createReducer, on } from '@ngrx/store';

// Interfaces
import { IAccidentList } from '@accidents/shared/interfaces/accidents';

// Actions
import * as ListAccidentsActions from '@accidents/store/actions/list-accidents.actions';
import { ISortingAndFilteringCriteria } from '@accidents/shared/interfaces/ship-accidents';

export interface AccidentsListState {
  accidents: IAccidentList;
  loadingAccidentsList: boolean;
  sortingAndFilteringCriteria: ISortingAndFilteringCriteria;
}

export const initialAccidentsListState: AccidentsListState = {
  accidents: undefined,
  loadingAccidentsList: false,
  sortingAndFilteringCriteria: null,
};

const AccidentsListReducer = createReducer(
  initialAccidentsListState,
  on(ListAccidentsActions.reset, state => ({
    ...initialAccidentsListState,
    sortingAndFilteringCriteria: state.sortingAndFilteringCriteria,
  })),
  on(ListAccidentsActions.getAccidentsListRequested, state => ({
    ...state,
    loadingAccidentsList: true,
  })),
  on(ListAccidentsActions.getAccidentsListResponse, (state, action) => ({
    ...state,
    accidents: action.payload,
    loadingAccidentsList: false,
  })),
  on(
    ListAccidentsActions.saveNewSortingAndFilteringCriteria,
    (state, action) => ({
      ...state,
      sortingAndFilteringCriteria: action.payload,
    })
  )
);

export function reducer(
  state: AccidentsListState | undefined,
  action: Action
): AccidentsListState {
  return AccidentsListReducer(state, action);
}
